// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caption-heading[data-v-6e0ef90a] {
  font-size: 18px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./admin/Index.3.vue","webpack://./../Index.3.vue"],"names":[],"mappings":"AACA;EACI,eAAA;EACA,gBAAA;ACAJ","sourcesContent":["\n.caption-heading {\n    font-size: 18px;\n    font-weight: 600;\n}\n",".caption-heading {\n  font-size: 18px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
